import VIDABOO_CONSTANTS from '../config/consts';
import {WSService, ShoutingRoomService} from './websocketService';
import userService from './restServices/userService';

////////////////////// Service Template Head  /////////////////////////

let privateState = {}; // private variables for this service.
let service = {};

////////////////////// End Service Template Head  /////////////////////////

////////////////////// Start Service Implementation:  /////////////////////////
privateState.myAvailability = VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE;
service.availabilityInitiated = false;
privateState.availabilityCallbackFunctions = [];
service.deleteWSListener = WSService.addConnectionEventListener((event) => {
  // assuming every user change (login/logout..) will also cause a WS_DISCONNECT and then WS_CONNECT event.
  if (event === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.CONNECTED) {
    privateState.reloadAvailabilityState();
  } else if (event === VIDABOO_CONSTANTS.WS_CONNECTION_STATES.DISCONNECTED) {
    privateState.deleteConnectToPeerShoutingRoom();
    privateState.deleteConnectToMyShoutingRoom();
    privateState.deleteWhenMessageReceivedFromShoutingRoom();
    privateState.deleteWhenMessageReceivedFromShoutingRoomServer();
    service.availabilityInitiated = false;
  }
});
service.setCurrentUser = (currentUser, setCurrentUser) => {
  privateState.currentUser = currentUser;
  privateState.setContextCurrentUser = setCurrentUser;
};

privateState.reloadAvailabilityState = () => {
  service.availabilityInitiated = false; // making sure this is false
  const userId = privateState.currentUser.userId;
  if (privateState.currentUser.guest) {
    //handle guest users that dont have profile
    privateState.myAvailability =
      VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE;
  } else {
    privateState.myAvailability = privateState.currentUser.availabilityStatus // todo- currentUser.availabilityStatus could be out of sync. https://consolto.atlassian.net/browse/CSSJ-349. Consider fetching currentUser here.
      ? VIDABOO_CONSTANTS.AVAILABILITY_STATES[
          privateState.currentUser.availabilityStatus.toUpperCase()
        ]
      : VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE;
  }

  console.debug('Reloading availbility: ' + privateState.myAvailability);

  privateState.deleteConnectToPeerShoutingRoom =
    ShoutingRoomService.connectToPeerShoutingRoom(
      // listening to my shouting room.
      privateState.currentUser.userId,
      privateState.currentUser.userId,
    );
  privateState.deleteConnectToMyShoutingRoom =
    ShoutingRoomService.connectToMyShoutingRoom(
      // in order to publish to my shouting room
      privateState.currentUser.userId,
    );

  privateState.doWhenMessageReceivedFromShoutingRoom = (data) => {
    if (
      data.messageType ===
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.AVAILABILITY_STATUS &&
      (data.senderUserId === 'server' || data.senderUserId === userId) &&
      data.content.roomId === userId
    ) {
      if (data.senderUserId === 'server') {
        if (!service.availabilityInitiated) {
          if (
            // in case we are "BUSY", we might publish that we're ONLINE / OFFLINE. Instead, need to wait
            // until we understand if we are BUSY and only if not BUSY, send the availability as saved in the currentUser.
            data.content.availabilityState !==
            VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
          ) {
            service.publishAvailabilityStatus(privateState.myAvailability); // iharel, 30.11.2019: MUST FIRST JOIN and only then PUBLISH my availability.
          } else {
            privateState.myAvailability = data.content.availabilityState; // in this case - BUSY
          }
        }
      } else {
        // availabilityState sent by me (either in this or another tab)
        privateState.myAvailability = data.content.availabilityState;
        console.debug(
          '**** CHANGED AVAILABILITY TO ' + data.content.availabilityState,
        );
      }

      service.availabilityInitiated = true;
      const functionsHash = privateState.availabilityCallbackFunctions;
      if (functionsHash !== undefined && functionsHash !== null) {
        Object.values(functionsHash).forEach((func) => {
          func(privateState.myAvailability);
        });
      }
    }
  };
  privateState.deleteWhenMessageReceivedFromShoutingRoomServer =
    ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
      'server',
      privateState.doWhenMessageReceivedFromShoutingRoom,
    );
  privateState.deleteWhenMessageReceivedFromShoutingRoom =
    ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
      userId,
      privateState.doWhenMessageReceivedFromShoutingRoom,
    );
};

service.setAvailability = function (newAvailability) {
  // sets the default availability for this user as well as publishes it
  const availabilityStatusMessage = {
    availabilityState: newAvailability,
    roomId: privateState.currentUser.userId,
  };

  userService.toggleAvailability(
    privateState.currentUser.userId,
    availabilityStatusMessage.availabilityState,
    (data) => {
      console.debug('Updating availability');
      const currentUser = {...privateState.currentUser};
      currentUser.availabilityStatus =
        VIDABOO_CONSTANTS.AVAILABILITY_STATES[data] ||
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE;
      privateState.setContextCurrentUser(currentUser);
    },
    (/* data */) => {
      console.debug("Couldn't change availability");
      return;
    },
  );

  privateState.myAvailability = newAvailability;
  console.debug(
    'publishing availability in setAvailability: ' +
      privateState.myAvailability,
  );

  service.publishAvailabilityStatus(newAvailability);
};

service.publishSavedAvailability = () => {
  service.publishAvailabilityStatus(
    privateState.currentUser.availabilityStatus
      ? VIDABOO_CONSTANTS.AVAILABILITY_STATES[
          privateState.currentUser.availabilityStatus.toUpperCase()
        ]
      : VIDABOO_CONSTANTS.AVAILABILITY_STATES.OFFLINE,
  );
};
service.publishAvailabilityStatus = (newAvailability) => {
  // Publishes availability but does NOT set the default availability for this user (unlike setAvailability())

  const availabilityStatusMessage = {
    availabilityState: newAvailability,
    roomId: privateState.currentUser.userId,
  };

  ShoutingRoomService.publishToShoutingRoom(
    availabilityStatusMessage,
    VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.AVAILABILITY_STATUS,
    privateState.currentUser.userId,
  );
};
service.getAvailability = function () {
  if (service.availabilityInitiated) return privateState.myAvailability;
  return false;
};
service.doWhenAvailabilityStateChanged = (callbackFunction) => {
  const callbackFunctionId =
    new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
  privateState.availabilityCallbackFunctions[callbackFunctionId] =
    callbackFunction;
  return () => {
    delete privateState.availabilityCallbackFunctions[callbackFunctionId];
  };
};

const availabilityStateService = {...service};
export default availabilityStateService;
